import toaster from '@/components/toaster/toaster';
import { setWishListCount } from '@/core/redux/commonSlice';
import store from '@/core/redux/store';
import { getData, postData } from '@/services/api.service';
import React, { useEffect, useState } from 'react';
import { FaTrashAlt, FaShoppingBag } from 'react-icons/fa'; // Importing React Icons
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import { addCartItem } from '@/core/redux/cartSlice';
import { classNames } from 'primereact/utils';
import Spinner from './spinner';
import { routePrefix, routes } from '@/utils/routes/routes';
import { RootState } from '@/core/redux/store';

const CustomerWishlist = () => {
  type WishlistItem = {
    id: number;
    name: string;
    price: number;
    image_path: string;
    productUrl?: string;
    type?: string;
    qty?: number;
    [key: string]: any;
  };
  const [wishlistItems, setWishlistItems] = useState<WishlistItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const user = store.getState().common.userDetails;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currencyCode = useSelector(
      (state: RootState) => state.common.header?.currency?.symbol
    );
  console.log(user);

  const getWishlistList = async () => {
    if (!user?.id) return;

    setIsLoading(true);
    const payload = {
      user_id: user?.id,
      action: 'list',
    };

    try {
      const response = await postData('wishlist', payload);
      if (response.status === 200 || response.status === 201) {
        const items = response?.data?.data || [];
        setWishlistItems(items);
        dispatch(setWishListCount(items.length));
      }
    } catch (error) {
      toast.error('Failed to load wishlist items');
      console.error('Error fetching wishlist:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user?.id) {
      getWishlistList();
    }
  }, [user?.id]);

  const handleRemove = async (id: number) => {
    if (!user?.id) return;

    const payload = {
      user_id: user?.id,
      action: 'delete',
      product_id: id,
    };

    try {
      const response = await postData('wishlist', payload);
      if (response.status === 200 || response.status === 201) {
        setWishlistItems((prevItems) =>
          prevItems.filter((item: WishlistItem) => item?.id !== id)
        );
        dispatch(setWishListCount(wishlistItems.length - 1));
        toast.success('Product removed successfully');
      }
    } catch (error) {
      toast.error('Failed to remove product');
      console.error('Error removing item:', error);
    }
  };

  const handleAddToCart = async (id: number, qty: number) => {
    // alert(id,qty);
    const payload = {
      id: id,
    };
    if (!user?.id) {
      toast.info('Please login to add items to cart');
      return;
    }

    try {
      const response = await getData(`/product_details/`, payload);
      const product = await response.data.data;
      // console.log(product)

      const AddToCartProduct = {
        user_id: user?.id,
        id: id,
        name: product?.product?.name,
        price: product?.product?.price,
        image: product?.product?.images[0],
        category_id: product?.category?.id,
        service_mode: product?.service_mode,
        quantity: qty,
        variant: '',
      };
      console.log(AddToCartProduct);
      dispatch(addCartItem(AddToCartProduct));
      toast.success('Item added to Cart');
      navigate(routes.cart);
    } catch (error) {
      toast.error('Failed to add product to cart');
      console.error('Error adding to cart:', error);
    }
  };

  const goToProductDetail = (id: any) => {
    navigate(`${routePrefix}/product-details/${id}`);
  };

  return (
    <div className="row">
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="col-md-12">
          <div className="user-dashboard-tab__content tab-content">
            <div
              className="tab-pane fade show active mar-top-30"
              id="addresses"
              role="tabpanel"
            >
              <div className="card-box table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th className="d-none d-lg-table-cell">
                        Price
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {wishlistItems?.length > 0 ? (
                      wishlistItems?.map((item: WishlistItem) => (
                        <tr key={item.id} className="align-middle">
                          {/* First TD: delete icon, image, name, price */}
                          <td>
                            <div className="d-flex align-items-center justify-content-between">
                              {/* Left side: icon, image, name */}
                              <div className="d-flex align-items-center gap-2">
                                <a
                                  href={item.productUrl}
                                  className="prodwl-img-card"
                                >
                                  <img
                                    src={item.image_path}
                                    alt={item.name}
                                    loading="lazy"
                                  />
                                </a>
                                <div className='d-flex flex-column wlist-prod'>
                                  <a
                                    href={item.productUrl}
                                    className="text-dark font-weight-bold"
                                  >
                                    {item.name}
                                  </a>
                                  <span
                                  className="btn-link"
                                  onClick={() => handleRemove(item.id)}
                                  aria-label="Remove from wishlist"
                                >
                                  Remove Item
                                </span>
                                </div>
                                
                              </div>

                              {/* Right side: price */}
                            </div>
                          </td>
                          <td>
                            <div className="price-with-symbol">
                              <span className='cur-symbol'>{currencyCode}</span><span className="fw-bold">{item.price}</span>
                            </div>
                          </td>

                          {/* Second TD: Add to cart */}
                          <td>
                            <div className="d-flex justify-content-center align-items-center">
                              {item.type == 'service' ? (
                                <button
                                  type="submit"
                                  className="button style1 add-to-cart-name"
                                  onClick={() => goToProductDetail(item.id)}
                                >
                                  View
                                </button>
                              ) : item?.qty == 0 ? (
                                <h5>Out of stock</h5>
                              ) : (
                                <form
                                  onSubmit={(e) => {
                                    e.preventDefault();
                                    handleAddToCart(item.id, 1);
                                  }}
                                >
                                  <input type="hidden" name="qty" value="1" />
                                  <button
                                    type="submit"
                                    className="btn btn-sm btn-primary d-flex align-items-center"
                                    aria-label="Add to cart"
                                  >
                                    <FaShoppingBag className="me-1" />{' '}
                                    <span>Add</span>
                                  </button>
                                </form>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="text-center py-4">
                          No items in wishlist.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerWishlist;
